import { render } from "./Contratti.vue?vue&type=template&id=65f14cc8"
import script from "./Contratti.vue?vue&type=script&lang=js"
export * from "./Contratti.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\germa\\dev\\es.client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__